(function () {
    'use strict';

    if (typeof window === 'undefined') {
        roleEnums(
            module.exports,
            require('./user.js'),
            require('lodash')
        );
    } else {
        RivalIQ.module('enums');
        roleEnums(RivalIQ.enums, RivalIQ.enums, window._);
    }

    function roleEnums(exports, enums, _) {

        exports.roles = {
            default: {
                id: 'default',
                name: 'default',
                fields: [
                    {
                        type: 'User',
                        field: [
                            'first_name',
                            'last_name',
                            'email',
                            'password',
                            'current_password',
                            'active_landscape_id',
                            'settings',
                            'email_enabled_default',
                            'state'
                        ],
                        conditions: function (actor, user) {
                            return actor.id === user.id;
                        }
                    }
                ]
            },
            owner: {
                id: 1,
                name: 'owner',
                displayName: 'Owner',
                permissions: [
                    // Users cannot destroy themselves or the account owner
                    {
                        type: 'User',
                        action: 'destroy',
                        conditions: function (actor, user) {
                            return (actor.id !== user.id &&
                                   actor.account_id === user.account_id &&
                                   user.role_id !== exports.roles.owner.id);
                        }
                    },
                    {
                        type: 'User',
                        action: '*',
                        conditions: function (actor, user) {
                            return actor.account_id === user.account_id;
                        }
                    },
                    {
                        type: 'Account',
                        action: [
                            'read',
                            'update',
                            'invite',
                            'createLandscape',
                            'listLandscapes',
                            'churn',
                            'spend'
                        ],
                        conditions: function (actor, account) {
                            return actor.account_id === account.id;
                        }
                    },
                    {
                        type: 'Landscape',
                        action: '*',
                        conditions: function (actor, landscape) {
                            return landscape.account_id === actor.account_id;
                        }
                    }
                ],
                fields: [
                    {
                        type: 'User',
                        field: [
                            'first_name',
                            'last_name',
                            'email',
                            'readOnlyLandscape'
                        ]
                    },
                    {
                        type: 'User',
                        field: [
                            'role_id'
                        ],
                        conditions: function (actor, user) {
                            return actor.id !== user.id;
                        }
                    }
                ]
            },
            full: {
                id: 2,
                name: 'full',
                displayName: 'Full',
                permissions: [
                    {
                        type: 'User',
                        action: 'destroy',
                        // Users cannot destroy themselves
                        conditions: function (actor, user) {
                            return (actor.id !== user.id &&
                                   actor.account_id === user.account_id &&
                                   user.role_id !== exports.roles.owner.id);
                        }
                    },
                    {
                        type: 'User',
                        action: '*',
                        conditions: function (actor, user) {
                            return actor.account_id === user.account_id;
                        }
                    },
                    {
                        type: 'Account',
                        action: [
                            'read',
                            'update',
                            'invite',
                            'createLandscape',
                            'listLandscapes',
                            'spend'
                        ],
                        conditions: function (actor, account) {
                            return actor.account_id === account.id;
                        }
                    },
                    {
                        type: 'Landscape',
                        action: ['read'],
                        conditions: function (actor, landscape) {
                            return landscape.account_id === actor.account_id;
                        }
                    },
                    {
                        type: 'Landscape',
                        action: ['create', 'update', 'destroy'],
                        conditions: function (actor, landscape) {
                            return landscape.account_id === actor.account_id &&
                                actor.account_user_status_id === enums.user.status.active.id;
                        }
                    }
                ],
                fields: [
                    {
                        type: 'User',
                        field: [
                            'first_name',
                            'last_name',
                            'email',
                            'readOnlyLandscape'
                        ]
                    },
                    {
                        type: 'User',
                        field: [
                            'role_id'
                        ],
                        conditions: function (actor, user) {
                            return user.role_id !== exports.roles.owner.id;
                        }
                    }
                ]
            },
            readOnly: {
                id: 3,
                name: 'readOnly',
                displayName: 'Client',
                permissions: [
                    {
                        type: 'User',
                        action: ['read', 'update'],
                        conditions: function (actor, user) {
                            return actor.id === user.id;
                        }
                    },
                    {
                        type: 'Account',
                        action: 'read',
                        conditions: function (actor, account) {
                            return actor.account_id === account.id;
                        }
                    }
                ],
                fields: []
            }
        };

        exports.getRole = function (id) {
            return _.find(exports.roles, {
                id: id
            });
        };

        exports.roleAction = function (actions, action) {
            if (_.isString(actions)) {
                return actions === '*' || actions === action;
            }
            return _.includes(actions, action);
        };
    }
})();
